export const placesSelector = (state) => state.places.places;
export const placeSelector = (state) => state.places.place;
export const loadingPlaceSelector = (state) => state.places.loading;
